import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Button, ScrollArea, Tooltip } from 'react-wot-bootstrap'
import SOUNDS from 'react-wot-bootstrap/lib/sounds'

import {
    LANDING_CLANS_DESCRITION,
    LANDING_CLANS_NO_DESCRITION,
    LANDING_CLANS_PROFILE_TOOLTIP,
} from '../../../../constants'
import { RecommendedClanPropTypes } from '../../../../../../propTypes'
import { openClanCard } from 'helpers/web_to_client'

import styles from './Back.scss'

export const Back = ({ description, children, clanNumber, clan }) => {
    const [isShadowVisible, setIsShadowVisible] = useState(false)
    const [scrollHeight, setScrollHeight] = useState(0)
    const scrollAreaRef = useRef(null)

    const onChangeScrollView = (isScrollbarVisible) => {
        if (isScrollbarVisible === isShadowVisible) return
        setIsShadowVisible(isScrollbarVisible)
    }

    useEffect(() => {
        const setScrollableAreaHeight = () => {
            if (!scrollAreaRef.current) return
            setScrollHeight(scrollAreaRef.current.clientHeight)
        }

        setScrollableAreaHeight()

        window.addEventListener('resize', setScrollableAreaHeight)

        return () => {
            window.removeEventListener('resize', setScrollableAreaHeight)
        }
    }, [])

    return (
        <div className={styles.base}>
            <div className={styles.header}>
                <span className={styles.title}>{LANDING_CLANS_DESCRITION}</span>
                <Button
                    type="secondary"
                    mixClassName={styles.clanButton}
                    tooltipId={`clan_profile_${clanNumber}`}
                    onClick={() => {
                        openClanCard({ id: clan.id, tag: clan.tag })
                    }}
                    buttonClickSoundId={SOUNDS.CLICK}
                >
                    <img className={styles.clanButtonImage} src={require('./images/banner.png')} alt="" />
                </Button>
                <Tooltip id={`clan_profile_${clanNumber}`}>{LANDING_CLANS_PROFILE_TOOLTIP}</Tooltip>
            </div>
            {description ? (
                <div className={cx(styles.scroll, isShadowVisible && styles.scroll__shadows)} ref={scrollAreaRef}>
                    <ScrollArea scrollableAreaHeight={scrollHeight} onChangeScrollView={onChangeScrollView}>
                        <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
                    </ScrollArea>
                </div>
            ) : (
                <div className={styles.noDescription}>{LANDING_CLANS_NO_DESCRITION}</div>
            )}
            {children}
        </div>
    )
}

Back.propTypes = {
    clan: RecommendedClanPropTypes,
    description: PropTypes.string,
    clanNumber: PropTypes.number,
}

export default Back



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/Card/components/Back/Back.jsx